import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { WorkersService } from 'src/app/modules/workers/_services/workers.service';
import { Worker } from 'src/app/modules/workers/_types/worker';
import { ContractWorker } from '../../_types/contract-worker';
import { ContractWorkersService } from '../../_services/contracts-workers.service';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-contract-workers-detail',
    templateUrl: './workers-detail.component.html',
    styleUrls: ['./workers-detail.component.css'],
    standalone: false
})
export class ContractWorkersDetailComponent implements OnInit {
  
  public workerFormGroup!: RxFormGroup;

  public contractWorker: ContractWorker = new ContractWorker();  
  public loading: boolean = false;  
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;  
  public workers: Array<Worker> = new Array<Worker>;
  public workersIds: Array<string> = [];
  

  constructor(
    private config: DynamicDialogConfig,
    private contractWorkersService: ContractWorkersService,
    private workerService: WorkersService,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService              
  ) {
    this.workerFormGroup = this.formBuilder.formGroup<ContractWorker>(this.contractWorker) as RxFormGroup;
  }
  

  ngOnInit(): void {    

    this.contractWorker.contractId = this.config.data.contractId;
    this.workersIds = this.config.data.workersIds;
            
    if(this.config.data.id!=null && this.config.data.id!='0'){
      this.loadContractWorker(this.config.data.id);
    }
    this.allowWrite = this.loginService.hasPermission("COMPANIES.WRITE");
    this.allowDelete = this.loginService.hasPermission("COMPANIES.DELETE");

    this.loadWorkers();
  }
  
  async loadContractWorker(id: string) {
    this.contractWorker = await firstValueFrom(this.contractWorkersService.get(id));
    this.workerFormGroup.patchValue(this.contractWorker);   
  }

  async loadWorkers(){

    let response = await firstValueFrom(this.workerService.all());         
    this.workers = response.data.filter((x: any) => x.id == this.contractWorker.workerId || !this.workersIds.some((y: any) => y == x.id));  

  }
      

  async save() {    
    let valid = this.formValidationService.validateForm(this.workerFormGroup);
    if (valid) {

      this.contractWorker = Object.assign(this.contractWorker, this.workerFormGroup.value);  
      let contractWorker:any = await firstValueFrom(this.contractWorkersService.save(this.contractWorker));
      
      this.dynamicDialogRef.close();      

      this.messageService.add({ closable: true, severity: 'success', detail: "Operario preferente guardado correctamente" });
    }else{
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });    
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Quieres eliminar el operario preferente?",
      header: "Eliminar opeario preferente",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractWorkersService.delete(this.contractWorker.id).subscribe(
          (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Operario preferente eliminado correctamente" });

            this.cancel();
          },
          (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        );
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }    

}
